export default __webpack_public_path__ + "static/media/malmo-s.d0dd25fd.webp";